import { UpdateTypeEnum } from "../enums/UpdateTypeEnum";
import { InstallationStatusEnum } from "../status/InstallationStatusEnum";
import { AggregationTypeEnum } from "./AggregationTypeEnum";
import { BinCountType } from "./BinCountType";
import { CashCountViewType } from "./CashCountViewType";
import { CashDistributionViewType } from "./CashDistributionViewType";
import { TransCountType } from "./TransCountType";
import { WidgetViewTypesEnum } from "./WidgetViewTypesEnum";

export class WidgetViewConfig {
    viewType: WidgetViewTypesEnum = WidgetViewTypesEnum.Number;
    color: string = "#e84e0f";
    icon: string = "bell";

    // status
    byStatus: Array<InstallationStatusEnum> = [];

    // considered as new (used in "installations status changes" widget)
    consideredAsNewMinutes: number = 0;

    // update status
    byUpdateType: UpdateTypeEnum = UpdateTypeEnum.Firmware;

    // cash count
    cashCountViewType: CashCountViewType = CashCountViewType.DistributionCount;
    binType: BinCountType = BinCountType.ByBinSize;
    binCount: number = 10;
    binSize: number = 1000;

    // cash distribution
    distributionType: CashDistributionViewType = CashDistributionViewType.DistributionCountTotal;

    // transaction
    countType: TransCountType = TransCountType.DenominationDistribution;
    aggregationType: AggregationTypeEnum = AggregationTypeEnum.AggregateByDayOfWeek;
    timeOfDayMinutesInterval: number = 60;

    fillFromJson(data: any) {
        this.icon = data.Icon;
        this.color = data.Color;
        this.viewType = data.ViewType;

        // status
        this.byStatus = data.ByStatus || [];

        // consideredAsNewMinutes
        this.consideredAsNewMinutes = data.ConsideredAsNewMinutes;

        // update status
        this.byUpdateType = data.ByUpdateType;

        // cash count
        this.cashCountViewType = data.CountType;
        if (data.BinConfiguration) {
            this.binType = data.BinConfiguration.BinType;
            this.binCount = data.BinConfiguration.BinCount;
            this.binSize = data.BinConfiguration.BinSize;
        }

        // cash distribution
        this.distributionType = data.DistributionType;

        // transaction
        this.countType = data.CountType;
        this.aggregationType = data.AggregationType;
        this.timeOfDayMinutesInterval = data.TimeOfDayMinutesInterval || 60;
    }

    clone(): WidgetViewConfig {
        var result = new WidgetViewConfig();

        result.viewType = this.viewType;
        result.color = this.color;
        result.icon = this.icon;
        result.byStatus = [...this.byStatus];
        result.consideredAsNewMinutes = this.consideredAsNewMinutes;
        result.byUpdateType = this.byUpdateType;

        result.cashCountViewType = this.cashCountViewType;
        result.binType = this.binType;
        result.binCount = this.binCount;
        result.binSize = this.binSize;

        result.distributionType = this.distributionType;

        result.countType = this.countType;
        result.aggregationType = this.aggregationType;
        result.timeOfDayMinutesInterval = this.timeOfDayMinutesInterval;

        return result;
    }
}
